import React from "react";
import { Text, View } from "react-native";
import { STYLES } from "../assets/styles";

function Badge({ value, size = "large", style = {} }) {
  const sizes = {
    small: STYLES.fontSizes.mini,
    medium: STYLES.fontSizes.mini * 1.3,
    large: STYLES.fontSizes.mini * 1.6,
  };
  return (
    <Text
      style={[
        {
          ...STYLES.shadow,
          fontSize: sizes[size],
          width: sizes[size] * 1.5,
          fontWeight: "bold",
          height: sizes[size] * 1.5,
          borderRadius: (sizes[size] * 1.5) / 2,
          backgroundColor: STYLES.colors.tomato,
          color: STYLES.colors.white,
          textAlign: "center",
          alignItems: "center",
        },
        style,
      ]}
    >
      {value}
    </Text>
  );
}

export default Badge;
